import { render, staticRenderFns } from "./settings-accessibility.vue?vue&type=template&id=ceb70fb6&"
import script from "./settings-accessibility.vue?vue&type=script&lang=js&"
export * from "./settings-accessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports